import React from 'react';
import { useT } from '../../i18n/LanguageContext';

export const emptyMerchantReview = () => ({
  depositReference: '',
  fundedDate: '',
  reviewReference: '',
  funded: false,
  included: false,
  clean: false,
});
export default function CashMerchantForms({ reviews, draft, edit, busy, uncertain, submit }) {
  const t = useT();
  const funding = reviews.funding.merchantFunding,
    adverse = reviews.adverse.merchantAdverseReview;
  return (
    <>
      <fieldset className="me-cash-card">
        <legend>{t('Merchant deposit')}</legend>
        {funding ? (
          <p>
            {t('Funded deposit {reference} · {date}. Recorded {recorded} by {actor}.', {
              reference: funding.depositReference,
              date: funding.fundedDate,
              recorded: new Date(funding.recordedAt).toLocaleString(),
              actor: funding.confirmedBy,
            })}
          </p>
        ) : (
          <p>
            {t(
              'Confirm the exact payment appears in a Funded deposit in the QuickBooks Merchant Service Center.'
            )}
          </p>
        )}
        {reviews.funding.canConfirm && (
          <form onSubmit={(event) => submit(event, 'funding')}>
            <fieldset disabled={busy || uncertain}>
              <div className="me-cash-grid">
                <label>
                  {t('Merchant deposit reference')}
                  <input
                    maxLength={120}
                    value={draft.depositReference}
                    onChange={(event) => edit('depositReference', event.target.value)}
                  />
                </label>
                <label>
                  {t('Merchant funded date')}
                  <input
                    type="date"
                    value={draft.fundedDate}
                    onChange={(event) => edit('fundedDate', event.target.value)}
                  />
                </label>
              </div>
              <label className="me-cash-authorize">
                <input
                  type="checkbox"
                  checked={draft.funded}
                  onChange={(event) => edit('funded', event.target.checked)}
                />
                {t('I verified the merchant deposit status is Funded.')}
              </label>
              <label className="me-cash-authorize">
                <input
                  type="checkbox"
                  checked={draft.included}
                  onChange={(event) => edit('included', event.target.checked)}
                />
                {t('I verified this exact payment and amount are included in that deposit.')}
              </label>
              <button type="submit" disabled={!draft.funded || !draft.included}>
                {t('Record merchant funding')}
              </button>
            </fieldset>
          </form>
        )}
      </fieldset>
      <fieldset className="me-cash-card">
        <legend>{t('Returns, refunds & disputes')}</legend>
        {adverse && (
          <p>
            {t('Review {reference} · {date} by {actor}.', {
              reference: adverse.reviewReference,
              date: new Date(adverse.reviewedAt).toLocaleString(),
              actor: adverse.reviewedBy,
            })}
          </p>
        )}
        <p>
          {t(
            'Check the exact payment in the Merchant Service Center. A successful processor status alone does not prove settlement.'
          )}
        </p>
        {reviews.adverse.reviewWindowMinutes !== null && (
          <p>
            {t('A review is current for {minutes} minutes.', {
              minutes: reviews.adverse.reviewWindowMinutes,
            })}
          </p>
        )}
        {reviews.adverse.canReview && (
          <form onSubmit={(event) => submit(event, 'adverse')}>
            <fieldset disabled={busy || uncertain}>
              <label>
                {t('Merchant review reference')}
                <input
                  maxLength={120}
                  value={draft.reviewReference}
                  onChange={(event) => edit('reviewReference', event.target.value)}
                />
              </label>
              <label className="me-cash-authorize">
                <input
                  type="checkbox"
                  checked={draft.clean}
                  onChange={(event) => edit('clean', event.target.checked)}
                />
                {t('I reviewed this payment and found no refunds, returns, or disputes.')}
              </label>
              <button type="submit" disabled={!draft.clean}>
                {t(adverse ? 'Renew merchant review' : 'Record merchant review')}
              </button>
            </fieldset>
          </form>
        )}
      </fieldset>
    </>
  );
}
